export default __webpack_public_path__ + "static/media/goadmob.d478ea2a.png";